import React from 'react'
import useSWR from 'swr'
import axios from 'axios'
import Post from './Post'

export const fetcher = async (url: string) => {
  const response = await axios.get(url)
  return response.data
}

interface PostsListProps {
  apiUrl: string
  title: string
  type: string
}

interface Data {
  top: {
    id: string
    title: string
    score: string
    url: string
    commentURL: string
    type: string
  }[]
  upvoted: {
    id: string
    title: string
    score: string
    url: string
    commentURL: string
    type: string
  }[]
}

const PostsList: React.FC<PostsListProps> = ({ apiUrl, title, type }) => {
  const { data, error } = useSWR<Data>(apiUrl, fetcher)

  if (error) return
  if (!data) return <div className="pt-4 pb-4 text-sm">Loading...</div>

  // @ts-ignore
  return !data ? (
    <div className="pt-4 pb-4 text-sm">
      {error && <div className="pt-4 pb-4 text-sm">Error loading posts</div>}
      Loading...
    </div>
  ) : (
    <div className="pt-4 pb-4">
      {error && <div className="pt-4 pb-4 text-sm">Error loading posts</div>}
      {type == 'HN' && data && data.top && data.top.map((post) => <Post key={post.id} {...post} />)}
      {type == 'HN2' &&
        data &&
        data.upvoted &&
        data.upvoted.map((post) => <Post key={post.id} clsSuf={'text-blue-900'} {...post} />)}
    </div>
  )
}

export default PostsList
